import { Link } from 'react-router-dom';

const LOGO_FONT_STYLE = {
  fontFamily: '"Avenir Next", -apple-system, BlinkMacSystemFont, sans-serif',
  fontWeight: 900,
};

/**
 * 전 페이지 공통 푸터.
 *
 * 홈과 법적 고지 문서가 각자 푸터를 갖고 있으면 사업자 정보가 중복되어 어긋난다
 * (실제로 홈에만 주소가 들어가고 문서 푸터에는 빠진 적이 있다).
 * 상호·주소·연락처·약관 링크는 여기 한 곳에서만 관리한다.
 */
export default function SiteFooter() {
  return (
    <footer className="bg-black text-white py-12 px-6">
      <div className="max-w-7xl mx-auto">

        {/*
          브랜드는 왼쪽, 링크 두 컬럼은 오른쪽에 붙여 배치한다.
          grid를 쓰면 마지막 컬럼이 컬럼 폭만큼 넓어져 텍스트 오른쪽에 빈 공간이
          남아 어중간하게 떠 보인다.
        */}
        <div className="flex flex-col gap-10 mb-10 md:flex-row md:justify-between md:gap-16">
          <div className="md:max-w-md">
            <Link
              to="/"
              className="inline-block text-4xl md:text-5xl font-black text-red-600"
              style={LOGO_FONT_STYLE}
            >
              Cupid
            </Link>
          </div>

          <div className="flex gap-12 sm:gap-16 md:shrink-0">
            <div>
              <h4 className="text-lg font-semibold mb-4 whitespace-nowrap">Download App</h4>
              <ul className="space-y-2 text-gray-400 text-sm">
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">App Store</a></li>
                <li><a href="#" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">Google Play</a></li>
              </ul>
            </div>
            <div>
              <h4 className="text-lg font-semibold mb-4 whitespace-nowrap">Support</h4>
              <ul className="space-y-2 text-gray-400 text-sm">
                <li>
                  <Link to="/notices" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                    공지사항
                  </Link>
                </li>
                <li>
                  <Link to="/account-deletion" className="hover:text-white transition-colors cursor-pointer whitespace-nowrap">
                    계정 및 데이터 삭제
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* 약관·정책과 사업자 정보를 하나의 하단 블록으로 묶는다(구분선 1개). */}
        <div className="border-t border-gray-800 pt-8 space-y-5">
          <ul className="flex flex-wrap items-center gap-x-5 gap-y-2 text-sm text-gray-300">
            <li>
              <Link to="/terms" className="hover:text-white transition-colors cursor-pointer">
                서비스 이용약관
              </Link>
            </li>
            <li>
              <Link to="/privacy" className="font-semibold hover:text-white transition-colors cursor-pointer">
                개인정보처리방침
              </Link>
            </li>
            <li>
              <Link to="/location-terms" className="hover:text-white transition-colors cursor-pointer">
                위치기반서비스 이용약관
              </Link>
            </li>
          </ul>

          <div className="text-gray-500 text-xs leading-relaxed">
            <p>
              사업자등록번호 438-37-01587&nbsp;&nbsp;|&nbsp;&nbsp;대표자 정지성&nbsp;&nbsp;|&nbsp;&nbsp;대표번호{' '}
              <a href="tel:010-4027-8182" className="hover:text-gray-300 transition-colors">010-4027-8182</a>
              &nbsp;&nbsp;|&nbsp;&nbsp;이메일{' '}
              <a href="mailto:support@cupidlab.io" className="hover:text-gray-300 transition-colors">support@cupidlab.io</a>
            </p>
            <p className="mt-1">서울특별시 송파구 충민로 10, 8층 S16-M117호(문정동, 가든파이브툴)</p>
          </div>

          <p className="text-gray-400 text-sm">© 2026 Cupid. All rights reserved.</p>
        </div>

      </div>
    </footer>
  );
}
